module.exports = "<svg>\n  <g id=\"links\"></g>\n  <g id=\"nodes\"></g>\n</svg>\n<div class=\"waitMessage\">\n  Bracket seeds have not yet been assigned; check here again after <span class=\"deadline\"></span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./bracketTab/template.html
// module id = 21
// module chunks = 0